'use client';

import type { RefObject } from 'react';
import { useEffect } from 'react';

interface ClickOutsideOptionsType {
  exceptList?: (HTMLElement | null)[];
  enable?: boolean;
}

export const useClickOutside = (
  targetRef: RefObject<HTMLElement | null>,
  onClickOutside: () => void,
  options?: ClickOutsideOptionsType
) => {
  const exceptList = options?.exceptList || [];
  const enable = !!options?.enable;

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        exceptList &&
        exceptList.length > 0 &&
        exceptList.some((el: any) => el?.contains(event.target))
      ) {
        return;
      }

      if (targetRef.current && !targetRef.current.contains(event.target)) {
        onClickOutside();
      }
    };

    const clearListeners = () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchdown', handleClickOutside);
    };

    clearListeners();
    if (!enable) return;

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchdown', handleClickOutside, {
      passive: true,
    });
    return clearListeners;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetRef, enable, exceptList]);
};
